import React from 'react';
import { motion } from 'framer-motion';
import { FiUsers, FiBook, FiBriefcase, FiAward } from 'react-icons/fi';
import Header from '../components/layout/Header';
import Card from '../components/ui/Card';
import Badge from '../components/ui/Badge';
import { CHARACTERS } from '../assets/characters';

const categories = [
  {
    title: 'Avocats en droit social',
    icon: <FiBriefcase size={24} />,
    color: '#1B2A4A',
    items: [
      { name: 'Cabinet Durand & Associés', desc: 'Spécialiste droit du travail - Paris', rating: '4.8/5' },
      { name: 'Me Sophie Lefebvre', desc: 'Droit social et négociation collective', rating: '4.9/5' },
    ],
  },
  {
    title: 'Organismes de formation',
    icon: <FiBook size={24} />,
    color: '#2D5F8A',
    items: [
      { name: 'FormaPro RH', desc: 'Formations management et leadership', rating: '4.7/5' },
      { name: 'Institut Compliance', desc: 'Conformité réglementaire et RGPD', rating: '4.6/5' },
    ],
  },
  {
    title: 'Cabinets RH',
    icon: <FiUsers size={24} />,
    color: '#4ECDC4',
    items: [
      { name: 'RH Solutions', desc: 'Conseil en organisation et transformation RH', rating: '4.5/5' },
      { name: 'Talent Partners', desc: 'Recrutement et marque employeur', rating: '4.7/5' },
    ],
  },
  {
    title: 'Experts QVT',
    icon: <FiAward size={24} />,
    color: '#27AE60',
    items: [
      { name: 'Bien-Être Pro', desc: 'Prévention des risques psychosociaux', rating: '4.8/5' },
      { name: 'Ergonomie Plus', desc: 'Aménagement postes de travail', rating: '4.6/5' },
    ],
  },
];

const MarketplacePage: React.FC = () => {
  return (
    <div>
      <Header title="Marketplace" subtitle="Trouvez les experts pour accompagner votre entreprise" />

      <div style={{ padding: '1.5rem 2rem' }}>
        {/* Banner experts */}
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          style={{
            background: 'linear-gradient(135deg, var(--color-primary), var(--color-secondary))',
            borderRadius: 'var(--radius-xl)',
            padding: '2rem 2.25rem',
            color: '#fff',
            marginBottom: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '1.5rem',
            flexWrap: 'wrap',
          }}
        >
          <div style={{ maxWidth: 480 }}>
            <h2 style={{ marginBottom: '0.5rem', color: '#fff' }}>Des experts à votre service</h2>
            <p style={{ opacity: 0.9, margin: 0, fontSize: 'var(--font-size-base)', lineHeight: 1.6 }}>
              Avocats, cabinets RH, formation et QVT : JULIA vous met en relation avec des professionnels
              pour sécuriser vos décisions.
            </p>
          </div>
          <img
            src={CHARACTERS.marketplace}
            alt=""
            aria-hidden
            style={{ width: 130, height: 'auto', flexShrink: 0 }}
          />
        </motion.div>

        {/* Category previews */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1.5rem' }}>
          {categories.map((cat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
            >
              <Card>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 'var(--radius-lg)',
                      background: `${cat.color}12`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: cat.color,
                    }}
                  >
                    {cat.icon}
                  </div>
                  <h3 style={{ margin: 0, fontSize: 'var(--font-size-lg)' }}>{cat.title}</h3>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  {cat.items.map((item, j) => (
                    <div
                      key={j}
                      style={{
                        padding: '0.75rem',
                        borderRadius: 'var(--radius-md)',
                        background: 'var(--color-bg)',
                        opacity: 0.6,
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <p style={{ fontWeight: 500, fontSize: 'var(--font-size-sm)' }}>{item.name}</p>
                          <p style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)' }}>{item.desc}</p>
                        </div>
                        <Badge variant="neutral" size="sm">{item.rating}</Badge>
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarketplacePage;
